/**
 * 공개 브랜딩 (탭 제목·헤더·푸터·문서 등).
 *
 * 로고 파일 — `public/` 에 넣을 이름(확장자까지 맞출 것):
 *   tripistocka-logo.png   — 헤더·푸터 옆 마크 (권장: 투명 배경, 세로 약 32~64px 이상 원본)
 *
 * 파비콘·PWA (기존 CRA 관례, 같은 이름으로 교체):
 *   favicon.ico
 *   logo192.png            — 192×192, apple-touch-icon 겸용
 *   logo512.png            — 512×512
 *
 * SVG 로고만 있으면 `BRAND_LOGO_FILE` 을 `tripistocka-logo.svg` 로 바꾸면 됩니다.
 */
export const APP_NAME = 'Tripistocka';

export const BRAND_LOGO_FILE = 'tripistocka-logo.png';

export function brandLogoSrc(): string {
  const base = process.env.PUBLIC_URL || '';
  const prefix = base.endsWith('/') ? base.slice(0, -1) : base;
  return `${prefix}/${BRAND_LOGO_FILE}`;
}
